import './ReactProductCarousel.scss'
import { ButtonTypes } from '@cox/core-ui8/dist/Button'

import { SKELETON_ITEMS } from '../../../constants'
import { Placeholder } from '../../shared/ReactBootstrap'

const ReactProductCarouselSkeleton = () => {
  return (
    <div className='carousel-item-container'>
      <div className='top-section col-sm-9'>
        <div className='carousel-badge'>
          <Placeholder
            as={'span'}
            style={{ height: '20px', width: '100px', backgroundColor: 'grey', borderRadius: '20px' }}
          />
        </div>
        <div className='carousel-icon'>
          <div className='img-placeholder skeleton-img-placeholder' />
        </div>
        <div className='item-eyebrow'>
          <div className='eyebrow-icon' style={{ backgroundColor: 'grey' }} />
          <Placeholder xs={7} />
        </div>
        <Placeholder className='header' xs={10} />
        <Placeholder className='additional-note' xs={6} />
        <Placeholder className='heading-description' xs={11} />
        <div className='bullet-list'>
          {SKELETON_ITEMS.map((bullet: string) => {
            return (
              <div className='bullet-list-item' key={JSON.stringify(bullet)}>
                <div className='bullet-icon skeleton-img-placeholder' />
                <Placeholder className='bullet-text' xs={7} />
              </div>
            )
          })}
        </div>
      </div>

      <div className='bottom-section col-sm-12'>
        <div className='plan-section'>
          <Placeholder className='plan-name' xs={7} />
          <div className='plan-price'>
            <Placeholder className='plan-price-actual' xs={7} />
            <Placeholder className='plan-price-crossed-out' xs={7} />
          </div>
          <Placeholder className='term-agreement' xs={7} />
          <div className='discount-applied'>
            <div className='discount-icon' style={{ backgroundColor: 'grey' }} />
            <p>
              <Placeholder as={'span'} xs={7} />
            </p>
          </div>
        </div>
        <div>
          <Placeholder.Button xs={8} variant={ButtonTypes.PRIMARY} style={{ marginBottom: '5px' }} />
          <Placeholder.Button xs={8} variant={ButtonTypes.SECONDARY} />
        </div>
      </div>
    </div>
  )
}

export default ReactProductCarouselSkeleton
